export const cookieVariabels = {
  exchangeSignalSelected: 'exchange-signal-selected',
}
